// contexts/AppContext.tsx - As opções do pedido (idades, matérias, objetivos, lugares e inclusão), vindas da
// API da Dinâmica. `null` quando não carregaram; a tela oferece tentar de novo.

import { createContext, useContext, ReactNode } from 'react';
import { OpcoesDisponiveis } from '../services/api';

interface AppContextType {
  opcoes: OpcoesDisponiveis | null;
  recarregarOpcoes: () => void;
}

const AppContext = createContext<AppContextType | undefined>(undefined);

export function AppProvider({ children, value }: { children: ReactNode; value: AppContextType }) {
  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
}

export function useAppContext() {
  const context = useContext(AppContext);
  if (context === undefined) {
    throw new Error('useAppContext must be used within an AppProvider');
  }
  return context;
}
